import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

interface CustomDropdownProps{
    data:string[]
}

const CustomDropdown = ({data=[]}:CustomDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center text-xss font-medium border rounded-md h-9 gap-1 px-3 outline-none w-full">
        <span className="text-black text-left flex-1">{data?.length ? data[0]:''}</span>
        <ChevronDown size={14} color="gray"/>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white" align="start">
        <div className="flex flex-col">
          {data?.map((item) => {
            return (
              <DropdownMenuItem
                key={item}
                className={`text-xss outline-none font-medium hover:cursor-pointer hover:bg-gray-50`}
              >
                {item}
              </DropdownMenuItem>
            );
          })}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CustomDropdown